<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="label mt-2">Search</div>
              <div class="row">
                <div class="col-3">
                  <div class="sub-label">SN:</div>
                  <b-form-input v-model="sn"
                                placeholder=""
                                label="Keywords:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-auto align-self-end" style="width: 11.5rem">
                  <b-button @click="search()" variant="primary">Search</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table v-if="searchedData!==[]":fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(FTIE_ID)="data">
            <div class="row">
              <div class="col-4 align-self-end">
                <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/ftie-page/${ data.item.FTIE_ID }`)">{{ data.item.FTIE_ID }}</a>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'custom-desc-dashboard',
    data() {
      return {
        function_name: 'Custom description Query',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userFunctions: [],
        userRoles: [],
        userSites: [],
        loadingCnt: 0,


        fields: [
          { key: 'FTIE_ID', label: 'FTIE', thClass: 'align-middle', thStyle: { 'min-width': '6.5rem !important' }, sortable: true },
          { key: 'NRE_ID', label: 'NRE', thClass: 'align-middle', sortable: true },
          { key: 'SKU_CODE', label: 'SKU', thClass: 'align-middle', sortable: true },
          { key: 'SHIPPING_PART_NO', label: 'Shipping PN', thClass: 'align-middle', sortable: true },
          { key: 'MPS_PART_NO', label: 'MPS PN', thClass: 'align-middle', sortable: true },
          { key: 'CUST_DESC', label: 'Custom Description', thClass: 'align-middle', sortable: true },
          { key: 'MODEL', label: 'Device', thClass: 'align-middle', sortable: true },
          //{ key: 'TYPE', label: 'Type', thClass: 'align-middle', sortable: true },
        ],
        searchByFtieId: null,
        searchedData: [],
        sn:'',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        already_first_search_flag: true,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        totalCount: '',
      }
    },
    created() {
      let self = this;


    },
    computed: {
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadingCnt = 0;
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
      },

      search() {
        if (this.loadingCnt == 0) {
          this.already_first_search_flag = false;
          this.loadingCnt = this.loadingCnt + 1;
        }
        this.currentPage = 1;
        this.getQuotes();
      },
      getQuotes() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/quote/list/';
        console.log('####getFties######');
        let request_data = {
          sn:self.sn,
          login_user_name: self.login_user_name,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        //let nreTotalCount = 2;
        let totalCount = 0;

        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['quote_info_list']);
              totalCount = parseInt(searchedData.length);
              console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            eventHub.$emit('loading', false);
            self.searchedData = searchedData;
            self.totalCount = totalCount;
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/CustomDescDashboard.vue